import { SET_FEATURES } from '../actions/types';

export default function features(state = {}, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_FEATURES:
				return action.payload;

			// no default
		}
	}

	return state;
}
